export const isFullMonthRange = dateRange => {
    if (!dateRange || dateRange.length !== 2) {
        return false;
    }

    const [start, end] = dateRange;

    return start.isSame(start.clone().startOf("month"), "day") && end.isSame(end.clone().endOf("month"), "day");
};
